import { HTTP } from '@community_dev/requests'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/api'

export function getDownloadUrl(filename: string, clientId: string, contextToken: string): Promise<string> {
  return request(ENDPOINTS.DOWNLOAD.replace(':clientId', clientId).replace(':fileName', filename), {
    method: HTTP.GET,
    headers: {
      Authorization: `Bearer ${contextToken}`,
    },
  }).then((data) => data.url)
}
